import {UnnormalizedProps as UnnormalizedStyleProps} from '@yosmanyga/core-style'
import {WithTheme} from '@yosmanyga/theme'
import {NonExistentPrimitiveError, usePrimitives} from '@yosmanyga/primitive-ui-spec'

type AnchorProps = {
    href: string,
    download?: string,
}

const Anchor = ({
    href, download, children,
    ...props
}: AnchorProps & UnnormalizedStyleProps) => {
    const {Anchor: BaseAnchor} = usePrimitives()

    if (!BaseAnchor) {
        throw new NonExistentPrimitiveError('Anchor')
    }

    return <BaseAnchor
        href={href}
        download={download}
        {...props}
    >
        {children}
    </BaseAnchor>
}

const AnchorWithTheme = (props: Props & CommonProps & UnnormalizedProps) => <WithTheme
    {...props}
    identifier='anchor'
    Component={Anchor}
/>

export default AnchorWithTheme
